import { Injectable, Injector } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { TasksService } from 'app/api';
import { SaveButtonService } from 'app/core/save-button/save-button.service';
import { TranslationTabService } from 'app/core/translation-tab/translation-tab.service';
import { BusinessProcessTaskService } from 'app/services/bp/business-process.service';

@Injectable()
export class VerifyService extends BusinessProcessTaskService {
    constructor(
        apiService: TasksService,
        saveButtonService: SaveButtonService,
        translationTabService: TranslationTabService,
        translocoService: TranslocoService,
        injector: Injector
    ) {
        super(apiService, saveButtonService, translationTabService, translocoService, injector);
        this.scope = 'bpVerify';
    }
}
